import { Injectable } from '@nestjs/common';
import { CheckListModelDTO } from './checklist-model.dto';
import { CheckListModelEntity } from '../checklist-model.entity';

@Injectable()
export class CheckListModelAdapter {

  public convertDtoToEntity(checklistmodelDTO: CheckListModelDTO, isUpdate: boolean = false): CheckListModelEntity {
    console.log(checklistmodelDTO);
    const checklistmodelentity = new CheckListModelEntity();
    checklistmodelentity.checkList = checklistmodelDTO.checkList;
    checklistmodelentity.createdUser = checklistmodelDTO.createdUser;
    if (checklistmodelDTO.checkListId) {
      checklistmodelentity.checkListId = checklistmodelDTO.checkListId
      checklistmodelentity.updatedUser = checklistmodelDTO.updatedUser
    }
    return checklistmodelentity;
  }
  public convertEntityToDto(checklistmodelentity: CheckListModelEntity): CheckListModelDTO {
    const checklistmodelDto = new CheckListModelDTO;
    checklistmodelDto.checkListId = checklistmodelentity.checkListId;
    checklistmodelDto.checkList = checklistmodelentity.checkList;
    checklistmodelDto.isActive = checklistmodelentity.isActive;
    checklistmodelDto.createdAt = checklistmodelentity.createdAt;
    checklistmodelDto.updatedAt = checklistmodelentity.updatedAt;
    checklistmodelDto.createdUser = checklistmodelentity.createdUser;
    checklistmodelDto.updatedUser = checklistmodelentity.updatedUser;
    checklistmodelDto.versionFlag = checklistmodelentity.versionFlag;
    return checklistmodelDto;
  }
}
